(function() {
  var module;

  try {
    // Get current templates module
    module = angular.module('manager');
  } catch (error) {
    // Or create a new one
    module = angular.module('manager', []);
  }

  module.run(['$templateCache', function($templateCache) {
    return $templateCache.put('components/logs/logs.tpl.html', [
'<section class="logs">',
'  <logger filter="true"></logger>',
'</section>',
'',''].join("\n"));
  }]);
})();